import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/src/app/bridge/hyper-core/page.tsx");
